import { render, staticRenderFns } from "./OrdersForm.vue?vue&type=template&id=09248d0e&scoped=true&"
import script from "./OrdersForm.vue?vue&type=script&lang=js&"
export * from "./OrdersForm.vue?vue&type=script&lang=js&"
import style0 from "./OrdersForm.vue?vue&type=style&index=0&id=09248d0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09248d0e",
  null
  
)

export default component.exports